import { Popover, PopoverDisclosure, PopoverProvider } from '@ariakit/react';
import classNames from 'classnames';
import { IconBell } from 'featherico';
import PropTypes from 'prop-types';
import { NavItemButton } from '../../../features/Navigation/Item';
import Button from '../../Button';
import NotificationsCount from '../NotificationsCount';
import NotificationsDropdown from '../NotificationsDropdown';
import styles from './style.m.less';

const propTypes = {
    showDropdown: PropTypes.bool.isRequired,
    actions: PropTypes.shape({
        doShowNotificationsDropdown: PropTypes.func.isRequired,
    }),
    count: PropTypes.number,
    compact: PropTypes.bool,
};

function NotificationsTrigger({ showDropdown, actions, hasAlert, count, compact }) {
    'use memo';

    return (
        <PopoverProvider
            placement={compact ? 'right-end' : 'top-start'}
            open={showDropdown}
            setOpen={isOpen => actions.doShowNotificationsDropdown(isOpen)}
        >
            <PopoverDisclosure
                render={
                    compact ? (
                        <NavItemButton
                            icon={<IconBell />}
                            label="Notifications"
                            notification={{ count, type: 'WARN' }}
                            compact
                            eventTracking={{ category: 'navigation header', action: 'click bell', value: count }}
                        />
                    ) : (
                        <NotificationsTriggerButton showDropdown={showDropdown} hasAlert={hasAlert} count={count} />
                    )
                }
            />
            <Popover gutter={5} unmountOnHide>
                <NotificationsDropdown onCloseClick={() => actions.doShowNotificationsDropdown(false)} />
            </Popover>
        </PopoverProvider>
    );
}

NotificationsTrigger.propTypes = propTypes;

function NotificationsTriggerButton({ hasAlert, showDropdown, count, ...props }) {
    'use memo';
    const buttonClasses = classNames(styles.button, {
        [styles.has_count]: hasAlert,
        [styles.dropdown_visible]: showDropdown,
    });
    return (
        <Button
            {...props}
            kind="PLAIN"
            className={buttonClasses}
            aria-label="Notifications"
            eventTracking={{ category: 'navigation header', action: 'click bell', value: count }}
        >
            <IconBell className={styles.bell} />
            <NotificationsCount />
        </Button>
    );
}

export default NotificationsTrigger;
